<template>
    <AuthenticatedShell full-bleed-brand>
        <div class="ea-mais-layout">
            <p class="ea-mais-text">
                Muito mais vindo por aí
            </p>
        </div>
    </AuthenticatedShell>
</template>

<script>
import AuthenticatedShell from '@/components/layout/AuthenticatedShell.vue';

export default {
    name: 'EscoMaisEmBreve',
    components: { AuthenticatedShell }
};
</script>

<style scoped>
.ea-mais-layout {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100%;
    padding: 2rem 1.5rem;
    box-sizing: border-box;
}

.ea-mais-text {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.88);
    text-align: center;
    line-height: 1.5;
}
</style>
